import styled from '@emotion/styled';

import { mediaQueries } from '@app/styles/theme/breakpoints';
import grid from '@app/styles/theme/grid';

interface ColumnProps {
  debug?: boolean;
  offset?: number[];
  span?: number[];
  children: React.ReactNode;
}

const Column = ({ debug, offset, span, children }: ColumnProps) => {
  return (
    <ColumnStyle debug={debug} offset={offset} span={span}>
      {children} {debug && !children && 'debug'}
    </ColumnStyle>
  );
};

export const ColumnStyle = styled.div<ColumnProps>(
  ({ debug, offset, span }) => {
    const style = {
      background: debug ? 'rgba(255,0,0,0.2)' : 'inherit',
    };

    mediaQueries.forEach((mq, index) => {
      const setOffset = () => {
        if (offset && offset.length > 0 && offset[index] !== 0) {
          return offset[index]
            ? offset[index]
            : offset[offset.length - 1] || 'auto';
        }
        return 'auto';
      };

      Object.assign(style, {
        [mq]: {
          gridColumn: `${setOffset()} / ${setSpan(span, grid, index)}`,
        },
      });
    });

    return style;
  },
);

export const setSpan = (spanValues, gridBreakpoints, mediaQueryIndex) => {
  if (
    spanValues &&
    spanValues.length > 0 &&
    spanValues[mediaQueryIndex] !== 0 &&
    typeof gridBreakpoints[mediaQueryIndex] !== 'undefined'
  ) {
    const breakpointColumns = gridBreakpoints[mediaQueryIndex].columns;

    const getValidSpan = (val) =>
      val > breakpointColumns ? breakpointColumns : val;

    return typeof spanValues[mediaQueryIndex] !== 'undefined'
      ? `span ${getValidSpan(spanValues[mediaQueryIndex])}`
      : `span ${getValidSpan(spanValues[spanValues.length - 1])}`;
  }
  return 'auto';
};

export default Column;
